export const baseDefaultContextProps = {
  usageTracker: {
    trackInteraction: () => undefined,
    trackPageView: () => undefined,
    trackUsage: () => undefined
  },
  callObjectId: 0,
  portalId: 0,
  openUrl: url => {
    window.open(url, '_blank');
  }
};